

import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LocationPicker from '../../Ordermanagment/Food/LocationPicker';
import Modal from '../../Ordermanagment/Food/Modal';
import { useLoader } from "../../../../context/LoaderProvider";
const initialRowsConfig = [
  { key: "Owner Name", value: "", isEditing: false, status: "Pending" },
  { key: "Company Name", value: "", isEditing: false, status: "Pending" },
  { key: "Register Documents", value: "", document: null, isEditing: false, isUpload: true, status: "Pending" },
  { key: "Website", value: "", isEditing: false, status: "Pending" },
  { key: "Phone No", value: "", isEditing: false, status: "Pending" },
  { key: "Email ID", value: "", isEditing: false, status: "Pending" },
  {
    key: "Address",
    value: {
      doorNo: "",
      street: "",
      city: "",
      state: "",
      pincode: "",
      landmark: "",
      latitude: "",   // ✅ added latitude
      longitude: ""   // ✅ added longitude
    },
    isEditing: false,
    status: "Pending",
    isMapPicker: true   // ✅ flag to show "Add Location" button
  },

  { key: "AADHAR CARD NO", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "PAN CARD NO", value: "", document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "Trade License", value: { startDate: "", endDate: "" }, document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "FSC License", value: { startDate: "", endDate: "" }, document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "Labour License", value: { startDate: "", endDate: "" }, document: null, isUpload: true, isEditing: false, status: "Not Uploaded" },
  { key: "GST No.", value: "", isEditing: false, status: "Not Verified" },
  {
    key: "Bank Details",
    value: { holderName: "", accountNumber: "", branchName: "", ifscCode: "", passbookFile: null, passbookServerFileName: "" },
    isEditing: false, status: "Pending"
  },
  { key: "Remarks", value: "", isEditing: false, status: "Pending" },
  // { key: "latitude", value: "", isEditing: false, status: "Pending" },
];


const Groceryregistration = ({ onNext }) => {
  const [vendorDetails, setVendorDetails] = useState(null);
  const [rows, setRows] = useState(
    initialRowsConfig.map(r =>
      r.key === "Remarks" ? { ...r, isEditing: false } : r
    )
  );


  const fileInputRefs = useRef([]);
  const nestedFileInputRefs = useRef({});
  const [userId, setUserId] = useState(null); // This will hold the potentially problematic userId
  const [loading, setLoading] = useState(false);
  const [vendorId, setVendorId] = useState(null);
  const [currentVendorId, setCurrentVendorId] = useState(null);
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const getRowConfigForKey = (key) => initialRowsConfig.find(r => r.key === key) || { value: {} };
  const [showMap, setShowMap] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState({
    doorNo: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
    latitude: "",
    longitude: ""
  });
  const [formRows, setFormRows] = useState([
    {
      key: "Address",
      value: selectedAddress,
      isEditing: false,
      status: "Pending",
      isMapPicker: true
    },
    // other rows...
  ]);


  const handleConfirmLocation = async () => {
    if (!selectedAddress.latitude || !selectedAddress.longitude) return;

    try {
      // 1️⃣ Reverse geocode to get address details
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${selectedAddress.latitude}&lon=${selectedAddress.longitude}`
      );
      const data = await response.json();

      // 2️⃣ Extract address components
      const address = data.address || {};
      const updatedAddress = {
        doorNo: address.house_number || "",
        street: address.road || "",
        city: address.city || address.town || address.village || "",
        state: address.state || "",
        pincode: address.postcode || "",
        landmark: address.neighbourhood || address.suburb || "",
        latitude: selectedAddress.latitude,
        longitude: selectedAddress.longitude
      };

      // 3️⃣ Update rows state (not formRows)
      setRows(prevRows =>
        prevRows.map(row =>
          row.key === "Address"
            ? { ...row, value: updatedAddress }
            : row
        )
      );

      // 4️⃣ Log updated address
      console.log("Selected Address:", updatedAddress);

      // 5️⃣ Hide the map
      setShowMap(false);
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };



  const getServerDocPlaceholder = useCallback((rowKey, details) => {
    if (!details) return null;
    switch (rowKey) {
      case "AADHAR CARD NO": return details.aadharFront ? { name: "Aadhaar Document (on server)" } : null;
      case "PAN CARD NO": return details.panCard ? { name: "PAN Document (on server)" } : null;
      case "Register Documents": return details.registeredDocumentsFront ? { name: "Registered Document (on server)" } : null;
      case "Trade License": return details.tradeLicense ? { name: "Trade License (on server)" } : null;
      case "FSC License": return details.fssaiLicense ? { name: "FSC License (on server)" } : null;
      case "Labour License": return details.labourLicense ? { name: "Labour License (on server)" } : null;
      case "Passbook": return details.passbook ? { name: "Passbook (on server)" } : null;
      default: return null;
    }
  }, []);



  const getStatusForDocumentField = useCallback((key, details) => {
    const initialStatus = getRowConfigForKey(key)?.status || "Pending";
    if (!details) return initialStatus;
    let hasDocOnServer = false; let isVerifiedByApi = false;
    switch (key) {
      case "AADHAR CARD NO": hasDocOnServer = !!details.aadharPhotoFront; isVerifiedByApi = !!details.aadharNumberStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.aadharNumber ? "Provided" : "Not Verified");
      case "PAN CARD NO": hasDocOnServer = !!details.panCard; isVerifiedByApi = !!details.panCardStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.panCardNumber ? "Provided" : "Not Verified");
      case "Register Documents": hasDocOnServer = !!details.registeredDocumentsFront; isVerifiedByApi = !!details.registeredDocumentsStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer ? "Provided" : "Pending");
      case "Trade License": hasDocOnServer = !!details.tradeLicense; isVerifiedByApi = !!details.tradeLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.tradeLicenseStartDate ? "Provided" : "Not Verified");
      case "FSC License": hasDocOnServer = !!details.fssaiLicense; isVerifiedByApi = !!details.fssaiLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.fssaiStartDate ? "Provided" : "Not Verified");
      case "Labour License": hasDocOnServer = !!details.labourLicense; isVerifiedByApi = !!details.labourLicenseStatus; return isVerifiedByApi ? "Verified" : (hasDocOnServer || details.labourStartDate ? "Provided" : "Not Verified");
      case "Passbook": hasDocOnServer = !!details.passbook; return hasDocOnServer ? "Provided" : "Not Uploaded";
      default: return initialStatus;
    }
  }, []);

  const handleProceed = () => {
    if (typeof onNext === 'function') onNext();
    else console.error("Registration: onNext prop is not a function!");
  };

  const mapAndSetRowsFromVendorDetails = useCallback((details) => {
    if (!details) {
      setRows(initialRowsConfig.map(r => ({ ...r, isEditing: r.key === "Remarks" ? false : r.isEditing, document: r.isUpload ? null : undefined })));
      return;
    }
    const updatedRows = initialRowsConfig.map(rowConfig => {
      const newRow = { ...rowConfig, document: rowConfig.isUpload ? null : undefined, isEditing: rowConfig.key === "Remarks" ? false : false };
      let valueFromApi;
      let statusFromApi = getRowConfigForKey(rowConfig.key)?.status || "Pending";

      switch (rowConfig.key) {
        case "Owner Name": valueFromApi = details.ownerName; if (details.hasOwnProperty('ownerNameStatus')) statusFromApi = details.ownerNameStatus ? "Verified" : (details.ownerName ? "Provided" : "Pending"); break;
        case "Company Name": valueFromApi = details.registeredName; if (details.hasOwnProperty('registeredNameStatus')) statusFromApi = details.registeredNameStatus ? "Verified" : (details.registeredName ? "Provided" : "Pending"); break;
        case "Business Plan": valueFromApi = details.businessPlan; if (details.hasOwnProperty('businessPlanStatus')) statusFromApi = details.businessPlanStatus ? "Verified" : (details.businessPlan ? "Provided" : "Pending"); break;
        case "Type": valueFromApi = details.type; if (details.hasOwnProperty('typeStatus')) statusFromApi = details.typeStatus ? "Verified" : (details.type ? "Provided" : "Pending"); break;
        case "Vendor Type": valueFromApi = details.vendorType; if (details.vendorType) statusFromApi = "Provided"; break;
        case "Outlet Vertical": valueFromApi = details.type; if (details.type) statusFromApi = "Provided"; break;
        case "Business Vertical": valueFromApi = details.businessVertical; if (details.businessVertical) statusFromApi = "Provided"; break;
        case "Website": valueFromApi = details.websiteName; if (details.hasOwnProperty('websiteNameStatus')) statusFromApi = details.websiteNameStatus ? "Verified" : (details.websiteName ? "Provided" : "Pending"); break;
        case "Phone No": valueFromApi = details.mobileNumber; if (details.hasOwnProperty('mobileNumberStatus')) statusFromApi = details.mobileNumberStatus ? "Verified" : (details.mobileNumber ? "Provided" : "Pending"); break;
        case "Email ID": valueFromApi = details.email; if (details.hasOwnProperty('emailStatus')) statusFromApi = details.emailStatus ? "Verified" : (details.email ? "Provided" : "Pending"); break;

        case "Address": {
          const defaultAddress = getRowConfigForKey("Address").value;
          valueFromApi = { ...defaultAddress, doorNo: details.doorNumber, street: details.addressLine, city: details.city, state: details.state, pincode: details.pincode !== undefined && details.pincode !== null ? String(details.pincode) : "", landmark: details.landMark, location: details.location };
          if (Object.values(valueFromApi).some(v => !!v)) statusFromApi = "Provided"; else statusFromApi = "Pending";
          break;
        }
        case "AADHAR CARD NO": valueFromApi = details.aadharNumber; newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "PAN CARD NO": valueFromApi = details.panCardNumber; newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "Trade License": valueFromApi = { startDate: details.tradeLicenseStartDate || "", endDate: details.tradeLicenseEndDate || "" }; newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "FSC License": valueFromApi = { startDate: details.fssaiStartDate || "", endDate: details.fssaiEndDate || "" }; newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "Labour License": valueFromApi = { startDate: details.labourStartDate || "", endDate: details.labourEndDate || "" }; newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "GST No.": valueFromApi = details.gstNumber; if (details.hasOwnProperty('gstNumberStatus')) statusFromApi = details.gstNumberStatus ? "Verified" : (details.gstNumber ? "Provided" : "Not Verified"); else if (details.gstNumber) statusFromApi = "Provided"; else statusFromApi = "Not Verified"; break;
        case "Register Documents": newRow.document = getServerDocPlaceholder(rowConfig.key, details); statusFromApi = getStatusForDocumentField(rowConfig.key, details); break;
        case "Bank Details": {
          const defaultBankDetails = getRowConfigForKey("Bank Details").value;
          valueFromApi = { ...defaultBankDetails, holderName: details.holderName, accountNumber: details.accountNumber, branchName: details.branchName, ifscCode: details.ifscCode, passbookFile: null };
          if (details.passbook) { valueFromApi.passbookServerFileName = "Passbook (on server)"; } else { valueFromApi.passbookServerFileName = ""; }
          const hasTextData = valueFromApi.holderName || valueFromApi.accountNumber || valueFromApi.branchName || valueFromApi.ifscCode;
          if (hasTextData || valueFromApi.passbookServerFileName) statusFromApi = "Provided"; else statusFromApi = "Pending";
          break;
        }
        case "Remarks": valueFromApi = details.remarks; if (details.remarks) statusFromApi = "Provided"; newRow.isEditing = false; break;
        default: valueFromApi = rowConfig.value;
      }
      newRow.value = valueFromApi !== undefined && valueFromApi !== null ? valueFromApi : rowConfig.value;
      newRow.status = statusFromApi;
      return newRow;
    });
    setRows(updatedRows);
  }, [getStatusForDocumentField, getServerDocPlaceholder]);

  const getVendorDetails = useCallback(async (vendorIdToFetchParam) => {
    if (!vendorIdToFetchParam) {
      setVendorDetails(null);
      mapAndSetRowsFromVendorDetails(null);
      return;
    }

    const token = localStorage.getItem("authToken"); // ✅ Get auth token from localStorage /api/vendor/get/{vendorId}
    setLoading(true);

    try {
      showLoader();
      const response = await fetch(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getById/${vendorIdToFetchParam}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`, // ✅ Include auth token
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "Error fetching and parsing error.",
        }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const fetchedVendorDetails = await response.json();

      // ✅ Store entire vendor data in localStorage using vendorId as key
      if (fetchedVendorDetails?.vendorId) {
        localStorage.setItem(
          `vendorData_${fetchedVendorDetails.vendorId}`,
          JSON.stringify(fetchedVendorDetails)
        );
      }

      setVendorDetails(fetchedVendorDetails);
      mapAndSetRowsFromVendorDetails(fetchedVendorDetails);
    } catch (error) {
      console.error("Failed to fetch vendor details:", error.message);
      // alert(`Error fetching data: ${error.message}. Form reset.`);
      setVendorDetails(null);
      mapAndSetRowsFromVendorDetails(null);
    } finally {
      setLoading(false);
      hideLoader();
    }
  }, [mapAndSetRowsFromVendorDetails]);





  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    console.log("Stored Vendor ID from localStorage:", storedVendorId);
    if (storedVendorId) {
      setCurrentVendorId(storedVendorId);
      getVendorDetails(storedVendorId);  // fetch vendor details based on vendorId
    } else {
      setCurrentVendorId(null);
      setVendorDetails(null);
      mapAndSetRowsFromVendorDetails(null);
    }
  }, [getVendorDetails, mapAndSetRowsFromVendorDetails]);


  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId"); // ✅ Get from localStorage
    const token = localStorage.getItem("authToken"); // Get token from localStorage

    if (storedVendorId && token) {
      showLoader();
      fetch(`http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getById/${storedVendorId}`, {
        headers: {
          "Authorization": `Bearer ${token}`, // send token in header
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(response => {
          if (response.status === 404) return null;
          if (!response.ok) {
            return response.json().then(err => {
              throw new Error(err.message || `HTTP error! ${response.status}`);
            });
          }
          return response.json();
        })
        .then(data => {
          if (data && data.vendorId) {
            setCurrentVendorId(data.vendorId);
            getVendorDetails(data.vendorId);

            // ✅ Print API data in alert boxsss
            // alert("Vendor Data:\n\n" + JSON.stringify(data, null, 2));

            // Optionally update token if returned in response headers or body
            if (data.token) {
              localStorage.setItem("authToken", data.token);
            }
          } else {
            setCurrentVendorId(null);
            setVendorDetails(null);
            mapAndSetRowsFromVendorDetails(null);
            alert("No vendor data found.");
          }
        })
        .catch(error => {
          console.error("Error fetching vendor ID by localStorage vendorId:", error);
          // alert(`Error fetching vendor data: ${error.message}`);
          setCurrentVendorId(null);
          setVendorDetails(null);
          mapAndSetRowsFromVendorDetails(null);
        });
    } else {
      setCurrentVendorId(null);
      setVendorDetails(null);
      mapAndSetRowsFromVendorDetails(null);
      alert("Vendor ID or token missing in localStorage.");
    }
  }, [getVendorDetails, mapAndSetRowsFromVendorDetails]);




  const handleEdit = (index) => {
    if (rows[index].key === "Remarks") return;
    setRows(prevRows => prevRows.map((r, i) => ({ ...r, isEditing: i === index })));
  };
  const handleSave = (index) => setRows(prevRows => prevRows.map((r, i) => i === index ? { ...r, isEditing: false } : r));

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    setRows(prevRows => prevRows.map((row, i) => {
      if (i === index) {
        if (file) return { ...row, document: file, status: "Uploaded" };
        const placeholder = getServerDocPlaceholder(row.key, vendorDetails);
        const status = getStatusForDocumentField(row.key, vendorDetails);
        return { ...row, document: placeholder, status: status };
      }
      return row;
    }));
    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = null;
  };

  const handleNestedFileChange = (e, rowIndex, fileFieldKeyInObject) => {
    const file = e.target.files[0] || null;
    setRows(prevRows => prevRows.map((row, i) => {
      if (i === rowIndex) {
        const updatedValue = { ...row.value, [fileFieldKeyInObject]: file };
        if (file && fileFieldKeyInObject === 'passbookFile') {
          updatedValue.passbookServerFileName = "";
        }
        return { ...row, value: updatedValue };
      }
      return row;
    }));
    if (e.target) e.target.value = null;
  };

  const handleUploadClick = (index) => fileInputRefs.current[index]?.click();

  const handleNestedUploadTrigger = (rowIndex, fileFieldKeyInObject) => {
    const refKey = `${rowIndex}_${fileFieldKeyInObject}`;
    if (nestedFileInputRefs.current[refKey]) {
      nestedFileInputRefs.current[refKey].click();
    }
  };


  const convertToBase64 = (file) => new Promise((resolve, reject) => { if (!file || !(file instanceof File)) { resolve(null); return; } const reader = new FileReader(); reader.onloadend = () => resolve(reader.result.split(',')[1]); reader.onerror = (error) => { console.error("FileReader error:", error); reject(error); }; reader.readAsDataURL(file); });
  const getValue = (key) => rows.find((r) => r.key === key)?.value;
  const getDocumentFile = (key) => { const row = rows.find((r) => r.key === key); return (row && row.document instanceof File) ? row.document : null; };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("authToken");

    if (!vendorId) {
      alert("Vendor ID is not available. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      const addressValue = getValue("Address");
      const bankDetailsValue = getValue("Bank Details");

      // ✅ Prepare vendor data
      const vendor = {
        ownerName: getValue("Owner Name") || null,
        registeredName: getValue("Company Name") || null,
        businessPlan: getValue("Business Plan") || null,
        type: getValue("Type") || null,
        vendorType: getValue("Vendor Type") || null,
        businessVertical: "FRESH_AND_GROCERIES",
        orderTypes: getValue("Order Type")?.length > 0 ? getValue("Order Type") : null,
        websiteName: getValue("Website") || null,
        mobileNumber: getValue("Phone No") || null,
        email: getValue("Email ID") || null,
        doorNumber: addressValue?.doorNo || null,
        addressLine: addressValue?.street || null,
        city: addressValue?.city || null,
        state: addressValue?.state || null,
        pincode: parseInt(addressValue?.pincode, 10) || null,
        landMark: addressValue?.landmark || null,
        location: addressValue?.location || null,
        aadharNumber: getValue("AADHAR CARD NO") || null,
        panCardNumber: getValue("PAN CARD NO") || null,
        gstNumber: getValue("GST No.") || null,
        tradeLicenseStartDate: getValue("Trade License")?.startDate || null,
        tradeLicenseEndDate: getValue("Trade License")?.endDate || null,
        fssaiStartDate: getValue("FSC License")?.startDate || null,
        fssaiEndDate: getValue("FSC License")?.endDate || null,
        labourStartDate: getValue("Labour License")?.startDate || null,
        labourEndDate: getValue("Labour License")?.endDate || null,
        holderName: bankDetailsValue?.holderName || null,
        accountNumber: bankDetailsValue?.accountNumber || null,
        branchName: bankDetailsValue?.branchName || null,
        ifscCode: bankDetailsValue?.ifscCode || null,
        remarks: getValue("Remarks") ?? null,

        // ✅ FIXED: always send valid latitude/longitude
        latitude: addressValue?.latitude || selectedAddress?.latitude || 17.3850,
        longitude: addressValue?.longitude || selectedAddress?.longitude || 78.4867,

        vendorId: vendorId,
      };

      // ✅ Build FormData
      const formDataToSend = new FormData();
      formDataToSend.append(
        "vendor",
        new Blob([JSON.stringify(vendor)], { type: "application/json" })
      );

      // Attach passbook file
      if (bankDetailsValue?.passbookFile instanceof File) {
        formDataToSend.append("passbook", bankDetailsValue.passbookFile);
      }

      // Attach other docs
      const docKeys = [
        { rowKey: "AADHAR CARD NO", formKey: "aadharPhoto", twoSided: true },
        { rowKey: "PAN CARD NO", formKey: "panCard" },
        { rowKey: "Register Documents", formKey: "registeredDocuments", twoSided: true },
        { rowKey: "Trade License", formKey: "tradeLicense" },
        { rowKey: "FSC License", formKey: "fssaiLicense" },
        { rowKey: "Labour License", formKey: "labourLicense" },
      ];

      docKeys.forEach(({ rowKey, formKey, twoSided }) => {
        const file = getDocumentFile(rowKey);
        if (file instanceof File) {
          if (twoSided) {
            formDataToSend.append(`${formKey}Front`, file);
            formDataToSend.append(`${formKey}Back`, file);
          } else {
            formDataToSend.append(formKey, file);
          }
        }
      });
      showLoader();
      const apiUrl = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/save?vendorId=${vendorId}`;

      console.log("📡 Sending POST:", apiUrl);
      console.log("🧾 Vendor JSON:", vendor);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      if (!response.ok) {
        const text = await response.text();
        console.error("❌ Server returned:", response.status, text);
        throw new Error(`HTTP ${response.status} — ${text}`);
      }

      const result = await response.json();
      console.log("✅ Server Response:", result);
      alert("Vendor registered successfully!");
      await getVendorDetails(result.vendorId);

    } catch (error) {
      console.error("🚨 Submission error (detailed):", error);
      alert(`Submission failed: ${error.message}`);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };





  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId); // ✅ Set it to state
    } else {
      console.warn("Vendor ID not found in localStorage.");
    }
  }, []);


  return (
    <div className="scrooltable" style={{ marginTop: "10px", padding: "0px" }}>
      <form onSubmit={handleSubmit}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Field</th>
              <th style={tableHeaderStyle}>Value</th>
              <th style={tableHeaderStyle}>Document</th>
              <th style={tableHeaderStyle}>Status</th>
              <th style={tableHeaderStyle}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.key} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                <td style={tableCellStyle}>{row.key}</td>

                <td style={tableCellStyle}> {/* Value Column */}
                  {row.isEditing && row.key !== "Remarks" ? (
                    row.key.includes("License") ? (
                      (row.value?.startDate !== undefined || row.value?.endDate !== undefined) ? (
                        <>
                          <div>
                            <input
                              type="date"
                              value={row.value.startDate || ""}
                              onChange={(e) =>
                                setRows((prevRows) =>
                                  prevRows.map((r, i) =>
                                    i === index
                                      ? { ...r, value: { ...r.value, startDate: e.target.value } }
                                      : r
                                  )
                                )
                              }
                              style={{
                                border: "1px solid #ccc",
                                padding: "5px",
                                width: "calc(100% - 12px)",
                                marginBottom: "5px",
                              }}
                              placeholder="Start Date"
                            />
                          </div>
                          <div>
                            <input
                              type="date"
                              value={row.value.endDate || ""}
                              onChange={(e) =>
                                setRows((prevRows) =>
                                  prevRows.map((r, i) =>
                                    i === index
                                      ? { ...r, value: { ...r.value, endDate: e.target.value } }
                                      : r
                                  )
                                )
                              }
                              style={{
                                border: "1px solid #ccc",
                                padding: "5px",
                                width: "calc(100% - 12px)",
                              }}
                              placeholder="End Date"
                            />
                          </div>
                        </>
                      ) : (
                        "Invalid license data structure"
                      )
                    ) : row.isMultiSelectDropdown ? (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {row.options.map((opt) => (
                          <label key={opt} style={{ marginBottom: "4px" }}>
                            <input
                              type="checkbox"
                              checked={row.value.includes(opt)}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? [...row.value, opt]
                                  : row.value.filter((v) => v !== opt);
                                setRows((prevRows) =>
                                  prevRows.map((r, i) =>
                                    i === index ? { ...r, value: newValue } : r
                                  )
                                );
                              }}
                            />{" "}
                            {opt}
                          </label>
                        ))}
                      </div>
                    ) : row.isDropdown ? (
                      <select
                        value={row.value || ""}
                        onChange={(e) =>
                          setRows((prevRows) =>
                            prevRows.map((r, i) =>
                              i === index ? { ...r, value: e.target.value } : r
                            )
                          )
                        }
                        style={{ width: "100%", border: "1px solid #ccc", padding: "5px" }}
                      >
                        <option value="">-- Select --</option>{" "}
                        {row.options.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    ) : row.key === "Address" || row.key === "Bank Details" ? (
                      typeof row.value === "object" && row.value !== null ? (
                        <>
                          {Object.entries(row.value).map(([k, v_val]) => {
                            if (k === "passbookFile" || k === "passbookServerFileName") return null;

                            // ✅ Make latitude & longitude readonly (just display them)
                            const isLatLng = k === "latitude" || k === "longitude";

                            return (
                              <div key={k} style={{ marginBottom: "5px" }}>
                                <input
                                  type="text"
                                  value={v_val || ""}
                                  onChange={(e) => {
                                    if (!isLatLng) {   // prevent editing latitude/longitude
                                      setRows((prevRows) =>
                                        prevRows.map((r, rowIndex) => {
                                          if (rowIndex === index) {
                                            const currentVal =
                                              typeof r.value === "object" && r.value !== null
                                                ? r.value
                                                : getRowConfigForKey(row.key).value;
                                            return {
                                              ...r,
                                              value: { ...currentVal, [k]: e.target.value },
                                            };
                                          }
                                          return r;
                                        })
                                      );
                                    }
                                  }}
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "5px",
                                    width: "calc(100% - 12px)",
                                    backgroundColor: isLatLng ? "#f5f5f5" : "#fff", // grey background for readonly
                                  }}
                                  placeholder={k
                                    .replace(/([A-Z])/g, " $1")
                                    .trim()
                                    .replace(/^\w/, (c) => c.toUpperCase())}
                                  readOnly={isLatLng}  // lock latitude & longitude
                                />
                              </div>
                            );
                          })}


                          {/* ✅ Add Location Button for Address */}
                          {row.key === "Address" && (
                            <div style={{ marginTop: "8px" }}>
                              <button
                                type="button"
                                onClick={() => setShowMap(true)}
                                style={{
                                  backgroundColor: "#4CAF50",   // ✅ Green primary color
                                  color: "#fff",               // ✅ White text
                                  padding: "10px 20px",        // ✅ Comfortable padding
                                  border: "none",              // ✅ Remove default border
                                  borderRadius: "8px",         // ✅ Rounded corners
                                  cursor: "pointer",           // ✅ Pointer on hover
                                  fontSize: "14px",            // ✅ Clean readable font
                                  fontWeight: "bold",          // ✅ Bold text
                                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // ✅ Subtle shadow
                                  transition: "all 0.3s ease", // ✅ Smooth hover effect
                                }}
                                onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                                onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
                              >
                                📍 Add Location
                              </button>

                            </div>
                          )}
                        </>
                      ) : (
                        <input type="text" value="Invalid data structure" disabled />
                      )
                    ) : (
                      <input
                        type={row.key === "Phone No" ? "tel" : "text"}
                        value={row.value || ""}
                        onChange={(e) =>
                          setRows((prevRows) =>
                            prevRows.map((r, i) =>
                              i === index ? { ...r, value: e.target.value } : r
                            )
                          )
                        }
                        style={{ width: "100%", border: "1px solid #ccc", padding: "5px" }}
                        placeholder={`Enter ${row.key}`}
                      />
                    )
                  ) : (
                    row.key === "Address" || row.key === "Bank Details" ? (
                      typeof row.value === "object" &&
                        row.value !== null &&
                        Object.values(row.value).some(
                          (val) =>
                            (typeof val === "string" && val.trim() !== "") ||
                            (typeof val === "object" && val !== null)
                        ) ? (
                        <>
                          {Object.entries(row.value).map(([k, v_val]) => {
                            if (k === "passbookFile" || k === "passbookServerFileName") return null;
                            if (
                              v_val &&
                              (typeof v_val === "string" || typeof v_val === "number")
                            ) {
                              return (
                                <div key={k}>
                                  <strong style={{ textTransform: "capitalize" }}>
                                    {k.replace(/([A-Z])/g, " $1").trim()}:
                                  </strong>{" "}
                                  {String(v_val)}
                                </div>
                              );
                            }
                            return null;
                          })}

                          {/* ✅ Show Add Location Button in view mode too */}
                          {row.key === "Address" && (
                            <div style={{ marginTop: "8px" }}>
                              <button type="button" onClick={() => setShowMap(true)} style={{
                                backgroundColor: "#4CAF50",   // ✅ Green primary color
                                color: "#fff",               // ✅ White text
                                padding: "10px 20px",        // ✅ Comfortable padding
                                border: "none",              // ✅ Remove default border
                                borderRadius: "8px",         // ✅ Rounded corners
                                cursor: "pointer",           // ✅ Pointer on hover
                                fontSize: "14px",            // ✅ Clean readable font
                                fontWeight: "bold",          // ✅ Bold text
                                boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // ✅ Subtle shadow
                                transition: "all 0.3s ease", // ✅ Smooth hover effect
                              }}
                                onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                                onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}>
                                Add Location
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <em>Not specified</em>
                      )
                    ) : row.key.includes("License") ? (
                      row.value?.startDate || row.value?.endDate ? (
                        <>
                          <strong>Start:</strong> {row.value.startDate || "N/A"},{" "}
                          <strong>End:</strong> {row.value.endDate || "N/A"}
                        </>
                      ) : (
                        <em>Not specified</em>
                      )
                    ) : (
                      row.value || <em>Not specified</em>
                    )
                  )}
                </td>

                <td style={tableCellStyle}> {/* Document Column */}
                  {/* ✅ Keeping your upload & Bank Details file logic unchanged */}
                  {row.isUpload ? (
                    <>
                      <button
                        type="button"
                        style={buttonStyle}
                        onClick={() => handleUploadClick(index)}
                      >
                        {row.document
                          ? row.document instanceof File
                            ? "Change File"
                            : "Replace Server File"
                          : "Upload File"}
                      </button>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        ref={(el) => (fileInputRefs.current[index] = el)}
                        onChange={(e) => handleFileChange(e, index)}
                      />
                      <div
                        style={{
                          marginTop: "5px",
                          fontSize: "0.9em",
                          wordBreak: "break-all",
                        }}
                      >
                        {row.document?.name ||
                          (row.document &&
                            typeof row.document === "object" &&
                            !row.document.name &&
                            row.document.name !== ""
                            ? "Server file present"
                            : "")}
                      </div>
                    </>
                  ) : row.key === "Bank Details" ? (
                    (() => {
                      let passbookDisplayStatus;
                      let statusColor = "orange";

                      if (row.value.passbookFile) {
                        passbookDisplayStatus = "File Selected";
                        statusColor = "#007bff";
                      } else {
                        passbookDisplayStatus = getStatusForDocumentField(
                          "Passbook",
                          vendorDetails
                        );
                        if (["Verified", "Provided"].includes(passbookDisplayStatus)) {
                          statusColor = "green";
                        }
                      }
                      return (
                        <>
                          {row.isEditing ? (
                            <>
                              <button
                                type="button"
                                style={buttonStyle}
                                onClick={() =>
                                  handleNestedUploadTrigger(index, "passbookFile")
                                }
                              >
                                {row.value.passbookFile
                                  ? "Change Passbook"
                                  : row.value.passbookServerFileName
                                    ? "Replace Server Passbook"
                                    : "Upload Passbook"}
                              </button>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                ref={(el) =>
                                  (nestedFileInputRefs.current[`${index}_passbookFile`] = el)
                                }
                                onChange={(e) =>
                                  handleNestedFileChange(e, index, "passbookFile")
                                }
                                accept="image/*,.pdf,.doc,.docx"
                              />
                              <div
                                style={{
                                  marginTop: "5px",
                                  fontSize: "0.9em",
                                  wordBreak: "break-all",
                                }}
                              >
                                {row.value.passbookFile?.name ||
                                  row.value.passbookServerFileName || (
                                    <em>No passbook selected</em>
                                  )}
                              </div>
                            </>
                          ) : (
                            <div
                              style={{
                                fontSize: "0.9em",
                                wordBreak: "break-all",
                              }}
                            >
                              {row.value.passbookServerFileName || (
                                <em>No passbook uploaded</em>
                              )}
                            </div>
                          )}
                          <div
                            style={{
                              fontSize: "0.9em",
                              color: statusColor,
                              marginTop: "5px",
                            }}
                          >
                            File Status: {passbookDisplayStatus}
                          </div>
                        </>
                      );
                    })()
                  ) : (
                    "-"
                  )}
                </td>

                <td style={tableCellStyle}> {/* Status Column */}
                  <span
                    style={{
                      color: ["Verified", "Uploaded", "Submitted", "Provided"].includes(
                        row.status
                      )
                        ? "green"
                        : ["Invalid", "Error", "Rejected", "Not Uploaded", "Not Verified", "Pending"].includes(
                          row.status
                        )
                          ? "orange"
                          : "grey",
                    }}
                  >
                    {row.status}
                  </span>
                </td>

                <td style={tableCellStyle}> {/* Actions Column */}
                  {row.key === "Remarks" ? (
                    <span>-</span>
                  ) : row.isEditing ? (
                    <button
                      type="button"
                      style={saveButtonStyle}
                      onClick={() => handleSave(index)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      type="button"
                      style={editButtonStyle}
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>


        </table>
        {/* {!currentVendorId && ( */}
        {!currentVendorId && (
          <button
            type="submit"
            style={{ ...submitAllButtonStyle, opacity: loading ? 0.7 : 1 }}
            disabled={loading} // Disable only when loading
          >
            {/* Simple text, as it only appears for initial submission */}
            {loading ? "Submitting..." : "Submit & Next"}
          </button>
        )}
        {/* // )} */}
        {/* <button type="submit" style={{ ...submitAllButtonStyle, opacity: loading ? 0.7 : 1 }} disabled={loading}> {loading ? (currentVendorId ? "Updating..." : "Submitting...") : (currentVendorId ? "Update All Details" : "Submit & Next")} </button> */}
      </form>
      {loading && <div style={{ marginTop: '10px', textAlign: 'center', fontWeight: 'bold' }}>Processing...</div>}
      {showMap && (
        <Modal onClose={() => setShowMap(false)}>
          <h3>Select Location</h3>
          <LocationPicker
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
          />
          <button
            onClick={handleConfirmLocation}
            style={{
              backgroundColor: "#4CAF50",   // ✅ Green primary color
              color: "#fff",               // ✅ White text
              padding: "10px 20px",        // ✅ Comfortable padding
              border: "none",              // ✅ Remove default border
              borderRadius: "8px",         // ✅ Rounded corners
              cursor: "pointer",           // ✅ Pointer on hover
              fontSize: "14px",            // ✅ Clean readable font
              fontWeight: "bold",          // ✅ Bold text
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // ✅ Subtle shadow
              transition: "all 0.3s ease", // ✅ Smooth hover effect
              marginTop: "10px",           // ✅ Keep your spacing
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
          >
            Confirm Location
          </button>

        </Modal>
      )}




    </div>

  );
};

const tableHeaderStyle = { border: "1px solid #ccc", padding: "10px", backgroundColor: "#b15cd6", color: "white", textAlign: "center" };
const tableCellStyle = { border: "1px solid #ccc", padding: "10px", verticalAlign: "top", textAlign: "left" };
const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#ffffff" };
const buttonStyle = { backgroundColor: "#5bc0de", color: "white", padding: "6px 12px", border: "none", borderRadius: "4px", cursor: "pointer", marginRight: "5px", marginBottom: '5px' };
const editButtonStyle = { ...buttonStyle, backgroundColor: "#f0ad4e" };
const saveButtonStyle = { ...buttonStyle, backgroundColor: "#5cb85c" };
const submitAllButtonStyle = { backgroundColor: "#008CBA", color: "white", padding: "10px 20px", border: "none", borderRadius: "5px", cursor: "pointer", marginTop: "20px" };

export default Groceryregistration;